export const AUDIO_PLAYER_STATUS = Object.freeze({
  idle: 'idle',
  active: 'active',
  inactive: 'inactive',
});
